import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { BORDER_RADIUS } from '@/constants/config';

export default function TopicResearchCallout({ accent }) {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();

  const styles = useMemo(() => StyleSheet.create({
    card: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      gap: 12,
      borderRadius: BORDER_RADIUS.medium,
      borderWidth: 1,
      borderColor: accent ? `${accent}44` : colors.border_color_secondary,
      backgroundColor: accent ? `${accent}0c` : colors.solid_color_block,
      padding: isXS ? 12 : 14,
    },
    iconWrap: {
      marginTop: 2,
      width: 28,
      height: 28,
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: accent ? `${accent}22` : colors.solid_color_tertiary,
    },
    content: { flex: 1, gap: 4, minWidth: 0 },
    eyebrow: {
      fontSize: 11,
      fontWeight: '800',
      letterSpacing: 1.1,
      opacity: 0.65,
      textTransform: 'uppercase',
    },
    body: { opacity: 0.88, lineHeight: 22 },
  }), [colors, isXS, accent]);

  const iconColor = accent || colors.text_color_secondary;

  return (
    <View style={styles.card} accessibilityRole="text">
      <View style={styles.iconWrap}>
        <Icon name="book" size={14} color={iconColor} />
      </View>
      <View style={styles.content}>
        <Text style={styles.eyebrow}>{t('pages.topics.researchEyebrow')}</Text>
        <Text type="p" size="s" style={styles.body}>
          {t('pages.topics.researchCallout')}
        </Text>
      </View>
    </View>
  );
}
